import * as React from 'react';
import { Box, Grid, Paper, Tab } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import InformacionMatriculaComponent from './components/InformacionMatricula';
import MatSeccionesView from '../mat_secciones/MatSeccionesView';

const PanelMatriculasView = () => {
  const [tab, setValue] = React.useState('2');

  const handleTabs = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Grid container spacing={1}>
      <Grid item md={4}>
        <InformacionMatriculaComponent />
      </Grid>
      <Grid item md={8}>
        <Paper elevation={4}>
          <TabContext value={tab}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleTabs} aria-label="lab API tabs example">
                {/* <Tab label="Estadísticas" value="1" /> */}
                <Tab label="Secciones" value="2" />
              </TabList>
            </Box>
            {/* <TabPanel value="1"></TabPanel> */}
            <TabPanel value="2" sx={{ padding: 0 }}>
              <MatSeccionesView />
            </TabPanel>
          </TabContext>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default PanelMatriculasView;
